import { makeStyles } from 'tss-react/mui';
import chroma from 'chroma-js';

export const useSlideCardStyles = makeStyles()((theme) => ({
  marginBottomStyle: { marginBottom: '0.5rem' },
  inlineBlockBoldStyle: { display: 'inline-block', fontWeight: 'bold' },
  inlineBlockStyle: { display: 'inline-block', overflowWrap: 'anywhere' },
  paper: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    marginTop: theme.spacing(2),
    marginBottom: '1rem',
    padding: '2rem 1rem',
  },
  imageWrapper: {
    height: '16rem',
    width: '12rem',
  },
  image: {
    height: '100%',
    objectFit: 'contain',
  },
  textWrapper: {
    width: '7rem',
    marginRight: '1rem',
    marginLeft: '1rem',
    marginTop: '-0.5rem',
  },
  isBrief: {
    padding: '0',
    margin: '0',
  },
}));

export const useSlideNavigatorStyles = makeStyles()(() => ({
  root: {
    display: 'grid',
    gridTemplateRows: 'auto auto 1fr',
    gap: 16,
    position: 'relative',
    height: 'calc(100% - 56px)',
  },
  slideNameLabel: {
    fontSize: '2rem',
    margin: 0,
    padding: 0,
    color: 'black',
    display: 'block',
  },
  filtersContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(270px, 1fr))',
    gap: 16,
  },
  formLabel: {
    fontSize: '1.5rem',
    color: 'black',
    display: 'block',
  },
  search: {
    padding: 0,
    margin: 0,
    background: 'white',

    '& .MuiInputBase-root': {
      boxSizing: 'border-box',
      minHeight: '38px',
    },
  },
  contentContainer: {
    display: 'grid',
  },
  dataContainer: {
    display: 'grid',
    gridTemplateRows: 'auto 1fr',
  },
  spinner: {
    position: 'absolute',
    zIndex: 1000,
    background: '#00000050',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'calc(100% + 48px)',
    width: 'calc(100% + 48px)',
    top: -24,
    left: -24,
  },
  pageInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: '1rem 0',
  },
  paginationContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  slidesContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
    gap: 24,
  },
  noDataPlaceholder: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    fontSize: '1.563rem',
  },
}));

export const selectColourStyles = {
  multiValue: (styles) => {
    const color = chroma('blue');
    
    return {
      ...styles,
      'z-index': 999,
      backgroundColor: color.alpha(0.1).css(),
    };
  },
  multiValueLabel: (styles, { data }) => ({
    ...styles,
    color: data.color,
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    color: data.color,
    ':hover': {
      backgroundColor: data.color,
      color: 'white',
    },
  }),
};
